// extracted by mini-css-extract-plugin
export default {"Form":"BookForm_Form__L-QOj","Stars":"BookForm_Stars__9Bj+J","AddImage":"BookForm_AddImage__7sG-1"};